<template>
  <div class="navetta-report">
    <div class="navetta-report-header">Fai una segnalazione:</div>
    <div class="navetta-report-body">
      <textarea name="navetta-report-input" v-model="text" cols="30" rows="10"></textarea>
    </div>
    <div v-on:tap="saveNotification()" class="navetta-report-button">Invia</div>
  </div>
</template>
<script>
import userService from '../services/User.service';
import store from '../stores';
import Notification from '../models/notification.model';
import { eventBus } from '../services/EventBus';
export default {
  name: 'RdsNavettaReport',
  data() {
    return {
      text: ''
    };
  },
  methods: {
    saveNotification() {
      const date = new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      const timestamp = date.getTime();
      const topic = 'navetta' + timestamp;
      const notification = new Notification({
        topic: topic,
        title: userService.user.name,
        body: this.text,
        author: userService.user.id
      });
      console.log('newNotification', notification);
      this.subscribeToTopic(topic);
      store.add('notification', notification);
      eventBus.$emit('hideNavettaReport');
    },
    subscribeToTopic(topic) {
      const user = userService.user;
      if (user.notificationsTopics.indexOf(topic) === -1) {
        user.notificationsTopics.push(topic);
        userService.updateUser(user);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.navetta-report {
  margin: 20px 21px 0;
  overflow-x: hidden;
  input,
  textarea {
    border: none;
    width: 100%;
    letter-spacing: 1px;
    font-size: 0.95em;
    padding: 25px;
    width: -webkit-fill-available;
    &::placeholder {
      color: #607d8b;
    }
  }
  textarea {
    height: 184px;
  }
  .navetta-report-header,
  .navetta-report-body,
  .navetta-report-button {
    border-radius: $default-border-radius;
  }
  .navetta-report-header {
    background-color: #ffffff;
    padding: 25px 20px;
    font-weight: 600;
  }
  .navetta-report-body {
    margin: 10px 0;
  }
  .navetta-report-button {
    background-color: #c12828;
    color: #ffffff;
    font-weight: 600;
    padding: 19px 0;
    text-align: center;
  }
}
</style>
